import I18n from 'I18n';
import isValidI18nKey from 'I18n/utils/isValidI18nKey';
import Products from 'merchandise-lib/constants/Product';
import FreeProducts from 'merchandise-lib/constants/FreeProduct';
import { logRavenException } from '../../utils/errors';
export const i18nKeysByApiName = {
  [FreeProducts.HUBSPOT_FREE]: 'upgrades.products.hubspotFree',
  [FreeProducts.MARKETING_HUB_FREE]: 'upgrades.products.hubspotFree',
  [FreeProducts.SALES_HUB_FREE]: 'upgrades.products.hubspotFree',
  [FreeProducts.SERVICE_HUB_FREE]: 'upgrades.products.hubspotFree',
  [FreeProducts.OPERATIONS_HUB_FREE]: 'upgrades.products.hubspotFree',
  [FreeProducts.CMS_HUB_FREE]: 'upgrades.products.hubspotFree',
  [Products.SALES_HUB_STARTER]: 'upgrades.products.salesStarter',
  [Products.SALES_HUB_PROFESSIONAL]: 'upgrades.products.salesPro',
  [Products.SALES_HUB_ENTERPRISE]: 'upgrades.products.salesEnterprise',
  [Products.MARKETING_HUB_BASIC]: 'upgrades.products.marketingBasic',
  [Products.MARKETING_HUB_STARTER]: 'upgrades.products.marketingStarter',
  [Products.MARKETING_HUB_PROFESSIONAL]: 'upgrades.products.marketingProfessional',
  [Products.MARKETING_HUB_ENTERPRISE]: 'upgrades.products.marketingEnterprise',
  [Products.SERVICE_HUB_STARTER]: 'upgrades.products.serviceStarter',
  [Products.SERVICE_HUB_PROFESSIONAL]: 'upgrades.products.serviceProfessional',
  [Products.SERVICE_HUB_ENTERPRISE]: 'upgrades.products.serviceEnterprise',
  [Products.OPERATIONS_HUB_STARTER]: 'upgrades.products.operations-starter',
  [Products.OPERATIONS_HUB_PROFESSIONAL]: 'upgrades.products.operations-professional',
  [Products.OPERATIONS_HUB_ENTERPRISE]: 'upgrades.products.operations-enterprise',
  [Products.CMS_HUB_STARTER]: 'upgrades.products.cmsStarter',
  [Products.CMS_HUB_PROFESSIONAL]: 'upgrades.products.cmsProfessional',
  [Products.CMS_HUB_ENTERPRISE]: 'upgrades.products.cmsEnterprise',
  [Products.CRM_SUITE_STARTER_BUNDLE]: 'upgrades.products.crm-suite-starter-bundle',
  [Products.CRM_SUITE_PROFESSIONAL_BUNDLE]: 'upgrades.products.crm-suite-professional-bundle',
  [Products.CRM_SUITE_ENTERPRISE_BUNDLE]: 'upgrades.products.crm-suite-enterprise-bundle',
  [Products.MARKETING_PLUS_SUITE_BUNDLE_PROFESSIONAL]: 'upgrades.products.marketing-plus-professional-bundle',
  [Products.MARKETING_PLUS_SUITE_BUNDLE_ENTERPRISE]: 'upgrades.products.marketing-plus-enterprise-bundle',
  [Products.ADS_LIMIT_INCREASE]: 'upgrades.products.ads',
  [Products.REPORTING_LIMIT_INCREASE]: 'upgrades.products.reporting',
  [Products.TECH_SERVICE_DEDICATED_IP_FOR_EMAIL]: 'upgrades.products.dedicatedIp',
  [Products.TRANSACTIONAL_EMAIL]: 'upgrades.products.transactionalEmail',
  [Products.WEB_HOSTING_CUSTOM_SSL_PACK]: 'upgrades.products.customSsl',
  [Products.MARKETING_SMS]: 'upgrades.products.marketing-sms',
  [Products.MARKETING_SMS_LIMIT_INCREASE]: 'upgrades.products.marketing-sms-limit-increase',
  [Products.DOMAINS_LIMIT_INCREASE]: 'upgrades.products.domains-limit-increase',
  [Products.SANDBOX_LIMIT_INCREASE]: 'upgrades.products.sandbox-limit-increase',
  [Products.CALLING_LIMIT_INCREASE]: 'upgrades.products.calling-limit-increase',
  [Products.PHONE_LIMIT_INCREASE]: 'upgrades.products.phone-limit-increase',
  [Products.TEAMS_LIMIT_INCREASE]: 'upgrades.products.teams-limit-increase',
  [Products.WHATSAPP_LIMIT_INCREASE]: 'upgrades.products.whatsapp-limit-increase',
  [Products.VIDEO_LIMIT_INCREASE]: 'upgrades.products.video-limit-increase',
  [Products.ESIGNATURE_LIMIT_INCREASE]: 'upgrades.products.esignature-limit-increase',
  [Products.WORKFLOWS_LIMIT_INCREASE]: 'upgrades.products.workflows-limit-increase',
  [Products.USERS_LIMIT_INCREASE]: 'upgrades.products.users-limit-increase',
  [Products.CUSTOM_OBJECTS_LIMIT_INCREASE]: 'upgrades.products.custom-objects-limit-increase',
  [Products.CALCULATED_PROPERTIES_LIMIT_INCREASE]: 'upgrades.products.calculated-properties-limit-increase',
  [Products.CUSTOM_PROPERTIES_LIMIT_INCREASE]: 'upgrades.products.custom-properties-limit-increase',
  [Products.CRM_OBJECT_LIMIT_INCREASE]: 'upgrades.products.crm-object-limit-increase',
  [Products.NON_MARKETING_CONTACTS_LIMIT_INCREASE]: 'upgrades.products.non-marketing-contacts-limit-increase',
  [Products.SERVICE_HUB_PROFESSIONAL_ONBOARDING]: 'upgrades.products.service-hub-professional-onboarding',
  [Products.SALES_HUB_PROFESSIONAL_ONBOARDING]: 'upgrades.products.sales-hub-professional-onboarding',
  [Products.BREEZE_INTELLIGENCE_CREDITS_100]: 'upgrades.products.breeze-intelligence-credits-100',
  [Products.BREEZE_INTELLIGENCE_CREDITS_1000]: 'upgrades.products.breeze-intelligence-credits-1000',
  [Products.BREEZE_INTELLIGENCE_CREDITS_10000]: 'upgrades.products.breeze-intelligence-credits-10000',
  [Products.BREEZE_INTELLIGENCE_CREDITS_100_COMMITTED]: 'upgrades.products.breeze-intelligence-credits-100-committed',
  [Products.BREEZE_INTELLIGENCE_CREDITS_1000_COMMITTED]: 'upgrades.products.breeze-intelligence-credits-1000-committed',
  [Products.BREEZE_INTELLIGENCE_CREDITS_10000_COMMITTED]: 'upgrades.products.breeze-intelligence-credits-10000-committed',
  [Products.COMMERCE_HUB_PROFESSIONAL]: 'upgrades.products.revenue-hub-professional',
  [Products.COMMERCE_HUB_ENTERPRISE]: 'upgrades.products.revenue-hub-enterprise',
  [Products.CORE_SEATS_PROFESSIONAL]: 'upgrades.products.core-seats-professional',
  [Products.CORE_SEATS_ENTERPRISE]: 'upgrades.products.core-seats-enterprise',
  [Products.CORE_SEATS_STARTER_HSOC]: 'upgrades.products.hsoc-core-seats-starter',
  [Products.CORE_SEATS_PROFESSIONAL_HSOC]: 'upgrades.products.hsoc-core-seats-professional',
  [Products.CORE_SEATS_ENTERPRISE_HSOC]: 'upgrades.products.hsoc-core-seats-enterprise',
  [Products.FRONT_OFFICE_SEATS_PROFESSIONAL]: 'upgrades.products.hsoc-front-office-seats-professional',
  [Products.FRONT_OFFICE_SEATS_ENTERPRISE]: 'upgrades.products.hsoc-front-office-seats-enterprise',
  [Products.GTM_SEATS_STARTER]: 'upgrades.products.hsoc-gtm-seats-starter',
  [Products.GTM_SEATS_PROFESSIONAL]: 'upgrades.products.hsoc-gtm-seats-professional',
  [Products.GTM_SEATS_ENTERPRISE]: 'upgrades.products.hsoc-gtm-seats-enterprise',
  [Products.OPS_SEATS_PROFESSIONAL]: 'upgrades.products.hsoc-ops-seats-professional',
  [Products.OPS_SEATS_ENTERPRISE]: 'upgrades.products.hsoc-ops-seats-enterprise'
};
export const getProductNameTextFromApiName = apiName => {
  const productLangKey = i18nKeysByApiName[apiName];
  if (!isValidI18nKey(`${productLangKey}`)) {
    logRavenException({
      customMessage: `Failed to get translation for: ${productLangKey}`,
      error: Error(`Unknown apiName: ${apiName}`)
    });
    return I18n.text('upgrades.products.default');
  }
  return I18n.text(`${productLangKey}`);
};